import { api } from "./../../config/api";
import { appendToFormData } from "../../helpers/form";

const basePath = "cliente-usuarios";

/**
 * Get all
 *
 * @param {Object} options
 *
 * @returns {Promise<T>}
 */
export const getAll = (options) => {
	const options_default = {};

	// Merge config
	options = Object.assign({}, options_default, options);

	let params    = [];
	let params_qs = "";

	if( options.hasOwnProperty("page") )
	{
		params.push(`page=${options.page}`);
	}

	if( options.hasOwnProperty("limit") )
	{
		params.push(`limit=${options.limit}`);
	}

	if( options.hasOwnProperty("search") )
	{
		params.push(`search=${options.search}`);
	}

	if( options.hasOwnProperty("orderBy") )
	{
		params.push(`orderBy=${options.orderBy}`);
	}

	if( options.hasOwnProperty("status") )
	{
		params.push(`status=${options.status}`);
	}

	if( options.hasOwnProperty("tipo_contrato") )
	{
		params.push(`tipo_contrato=${options.tipo_contrato}`);
	}

	if ( options.hasOwnProperty("resale_id") )
	{
		params.push(`resale_id=${options.resale_id}`);
	}

	if( options.hasOwnProperty("created_at") )
	{
		options.created_at.forEach((item, index) => {
			params.push(`created_at[${index}]=${item}`);
		});
	}

	if( params.length )
	{
		params_qs = `?${params.join("&")}`;
	}

	if( options.exportItems )
	{
		return api.get(`${basePath}/${options.client_uuid}/export${params_qs}`);
	}
	else
	{
		return api.get(`${basePath}/${options.client_uuid}${params_qs}`);
	}
};

/**
 * Create
 *
 * @param {string} client_uuid
 * @param {Object} options
 *
 * @returns {Promise<T>}
 */
 export const create = (client_uuid, options) => {
	const formData = new FormData();

	for( let key in options )
	{
		if( options.hasOwnProperty(key) )
		{
			appendToFormData(formData, key, options[key]);
		}
	}

	return api.post(`${basePath}/${client_uuid}`, formData);
};

/**
 * Edit
 *
 * @param {string} client_uuid
 * @param {Object} options
 *
 * @returns {Promise<T>}
 */
 export const edit = (client_uuid, options) => {
	const formData = new FormData();

	for( let key in options )
	{
		if( options.hasOwnProperty(key) )
		{
			appendToFormData(formData, key, options[key]);
		}
	}

	return api.post(`${basePath}/${client_uuid}/${options.uuid}`, formData);
};

/**
 * Show
 *
 * @param {string} client_uuid
 * @param {Object} options
 *
 * @returns {Promise<T>}
 */
export const show = (client_uuid, options) => {
	return api.get(`${basePath}/${client_uuid}/${options.uuid}`);
};

/**
 * Delete
 *
 * @param {string} client_uuid
 * @param {Object} options
 *
 * @returns {Promise<T>}
 */
export const destroy = (client_uuid, options) => {
	return api.delete(`${basePath}/${client_uuid}/${options.uuid}`);
};
